/* eslint-disable react-hooks/exhaustive-deps */
import { Row } from 'antd'
import { Offer } from 'src/core/models'
import React, { useEffect } from 'react'
import { useTranslation } from 'next-i18next'
import { showNotification } from 'src/core/helpers'
import { MessageItemButton, CustomCol } from 'src/components'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import styles from './OffertDetailsButtonsContent.module.scss'
import { CheckOutlined, CloseCircleOutlined, RollbackOutlined } from '@ant-design/icons'
import {
  acceptOffer, acceptOfferSelector, declineOffer, resetOffersDeclineState,
  declineOfferSelector, resetOffersAcceptState, userAuthenticatedState
} from 'src/features'

interface OffsetDetailsButtonsContentProps {
  offer: Offer
  handleClose: () => void
}

const OffsetDetailsButtonsContent: React.FC<OffsetDetailsButtonsContentProps> = ({ offer, handleClose }) => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const user = useAppSelector(userAuthenticatedState)
  const { success: sucessDeclined, loading: loadingDecline } = useAppSelector(declineOfferSelector)
  const { success: sucessAccept, loading: loadingAccept } = useAppSelector(acceptOfferSelector)

  const showReceiverButtons = user?.id === offer.receiver && offer.state === 'active'
  const showSenderButtons = user?.id !== offer.receiver && offer.state === 'active'

  useEffect(() => {
    if (sucessDeclined) {
      handleClose()
      showNotification('success', t('general.OperationSuccess'))
      dispatch(resetOffersDeclineState())
    }
  }, [sucessDeclined])

  useEffect(() => {
    if (sucessAccept) {
      handleClose()
      showNotification('success', t('general.OperationSuccess'))
      dispatch(resetOffersAcceptState())
    }
  }, [sucessAccept])

  return <>
    {showReceiverButtons && (
      <Row className={styles.row}>
        <CustomCol>
          <MessageItemButton
            handleClick={() => dispatch(declineOffer(offer.id, 'declined'))}
            label={loadingDecline ? t('Offers.Declining') : t('Offers.Decline')}
            icon={<CloseCircleOutlined />}
            isBlocked={false}
            loading={loadingDecline}
          />
        </CustomCol>
        <CustomCol>
          <MessageItemButton
            handleClick={() => dispatch(acceptOffer(offer.id))}
            label={loadingAccept ? t('Offers.Accepting') : t('Offers.Accept')}
            icon={<CheckOutlined />}
            type='primary'
            isBlocked={false}
            loading={loadingAccept}
          />
        </CustomCol>
      </Row>
    )}

    {showSenderButtons && (
      <MessageItemButton
        handleClick={() => dispatch(declineOffer(offer.id, 'cancelled'))}
        label={loadingDecline ? t('Offers.Cancelling') : t('Offers.Cancel')}
        icon={<RollbackOutlined />}
        loading={loadingDecline}
      />
    )}
  </>
}

export default OffsetDetailsButtonsContent
